import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TagDTO } from "@core/models";

@Component({
  selector: "app-driveb-tag-list",
  templateUrl: "./tag-list.component.html",
  styleUrls: ["./tag-list.component.scss"],
  standalone: false
})
export class TagListComponent {
  @Input() title = "service-request.tag.popover-title";
  @Input() showTitle = true;
  @Input() tags: TagDTO[] = [];
  @Input() removable = true;
  @Input() maxVisible = 5;
  @Output() remove = new EventEmitter<TagDTO>();

  readonly itemHeight = 36;
  readonly itemGap = 6;

  get maxListHeight(): number {
    if (this.maxVisible <= 0) {
      return 0;
    }

    return this.maxVisible * this.itemHeight + (this.maxVisible - 1) * this.itemGap;
  }

  onRemoveTag(tag: TagDTO): void {
    this.remove.emit(tag);
  }
}
